namespace JupitersChoice {
    export class PaylineWinText extends Sapphire.Text {

        private _offsetX: number;
        private _offsetY: number;

        private _intendedX: number;
        private _intendedY: number;

        private _offsetScale: any;

        constructor() {
            super();
        }

        construct(data: any) {
            super.construct(data);
            this._offsetX = this._data.get('x',0);
            this._offsetY = this._data.get('y',0);
            this._offsetScale = this._data.get('offsetScale',{x:1,y:1});
            this.setPosition(0,0);
        }

        private updateCurrentPosition(): void{
            this.x = this._offsetX + (this._offsetScale.x*this._intendedX);
            this.y = this._offsetY + (this._offsetScale.y*this._intendedY);
        }

        setOrientation(orientation: string): void {
            super.setOrientation(orientation);
            

            this._offsetX = this._data.get('x',0);
            this._offsetY = this._data.get('y',0);
            this._offsetScale = this._data.get('offsetScale',{x:1,y:1});

            this.updateCurrentPosition();

            this.updateLayout();
        }

        setPosition(x: number,y: number){
            this._intendedX = x;
            this._intendedY = y;
            this.updateCurrentPosition();
        }
    }
}